<template>
	<div>
		<article class="tocitem" v-if="mode == 'pdf'" :title="$t('message.contragent_search.enterprise_risk_scan')"></article>
		<tmp-risk-scan-cn :data="risk" :mode="mode"></tmp-risk-scan-cn>

		<article class="tocitem" v-if="mode == 'pdf'" :title="$t('message.contragent_search.annual_report')"></article>
		<div class="table-responsive">
			<h4 class="service-response-h4">
				{{ $t("message.contragent_search.annual_report") }}
			</h4>
			<div v-for="(result, index) in results" :key="'res-an-rep-' + index" class="result-block mb-3">
				<div>
					<h5 class="service-response-h4">
						{{ $t("message.contragent_search.AssetsData") }}
					</h5>
					<div>
						<div v-if="mode != 'pdf'">
							<b-table :fixed="true" :fields="assets_data_fields"
								:items="resultsData(result, 'AssetsData')"></b-table>
						</div>
						<div v-if="mode == 'pdf'">
							<b-table :fixed="true" :fields="assets_data_fields_pdf[0]"
								:items="resultsData(result, 'AssetsData')"></b-table>
							<br />
							<b-table :fixed="true" :fields="assets_data_fields_pdf[1]"
								:items="resultsData(result, 'AssetsData')"></b-table>
						</div>

					</div>
				</div>

			</div>


		</div>
	</div>
</template>
<script>
export default {
	name: "ShortSearchResults",
	props: ["data", "mode"],
	data() {
		return {
			results: {},
			risk: {},
			assets_data_fields_pdf: [
				[
					{
						key: "No",
						label: this.$t("message.contragent_search.No"),
						thClass: "row-grid",
						tdClass: "row-grid",
					},
					{
						key: "GrossTradingIncome",
						label: this.$t("message.contragent_search.GrossTradingIncome"),
						thClass: "row-grid",
						tdClass: "row-grid",
					},
					{
						key: "MainBusinessIncome",
						label: this.$t("message.contragent_search.MainBusinessIncome"),
						thClass: "row-grid",
						tdClass: "row-grid",
					},
				],
				[
					{
						key: "NetProfit",
						label: this.$t("message.contragent_search.NetProfit"),
						thClass: "row-grid",
						tdClass: "row-grid",
					},
					{
						key: "TotalTaxAmount",
						label: this.$t("message.contragent_search.TotalTaxAmount"),
						thClass: "row-grid",
						tdClass: "row-grid",
					},
					{
						key: "TotalProfit",
						label: this.$t("message.contragent_search.TotalProfit"),
						thClass: "row-grid",
						tdClass: "row-grid",
					},
				],
			],
			assets_data_fields: [
				{
					key: "No",
					label: this.$t("message.contragent_search.No"),
					thClass: "row-grid",
					tdClass: "row-grid",
				},
				{
					key: "GrossTradingIncome",
					label: this.$t("message.contragent_search.GrossTradingIncome"),
					thClass: "row-grid",
					tdClass: "row-grid",
				},
				{
					key: "MainBusinessIncome",
					label: this.$t("message.contragent_search.MainBusinessIncome"),
					thClass: "row-grid",
					tdClass: "row-grid",
				},
				{
					key: "NetProfit",
					label: this.$t("message.contragent_search.NetProfit"),
					thClass: "row-grid",
					tdClass: "row-grid",
				},
				{
					key: "TotalTaxAmount",
					label: this.$t("message.contragent_search.TotalTaxAmount"),
					thClass: "row-grid",
					tdClass: "row-grid",
				},
				{
					key: "TotalProfit",
					label: this.$t("message.contragent_search.TotalProfit"),
					thClass: "row-grid",
					tdClass: "row-grid",
				},
			],
		}
	},
	methods: {
		resultsData(result, field) {
			return result.results.map((result_) => {
				return result_[field];
			});
		},
	},
	watch: {
		data: function (newVal, oldVal) {
			this.results = newVal.annual;
			this.risk = newVal.risk;
		},
	},
	mounted() {
		console.log('results mounded');
		console.log(this.data);
		this.results = this.data.annual;
		this.risk = this.data.risk;
	},
}
</script>